import { API, get, post } from "api";
import { OK } from "http-status-codes";
import { MatSpecBriefingFormUpdateModel } from "pages/BriefingForm/interfaces";

export const getBriefForm = async (headers: HeadersInit, id: string) => {
    const { parsedBody } = await get<{ data: string }>(`${API.baseApiUrl}/2adpro/load?matspec=${id}`, { headers });

    return parsedBody?.data ? JSON.parse(parsedBody.data) : undefined;
};

export const postBriefFormAssetReq = async (headers: HeadersInit, formData: FormData) => {
    const { parsedBody } = await post(
        `${API.baseApiUrl}/assets`,
        formData,
        {
            headers,
        },
        false
    );
    return parsedBody;
};

export const postBriefFormReq = async (
    headers: HeadersInit,
    { materialSpecificationId, salesRep, adDesign, adSize, digitalBrief }: MatSpecBriefingFormUpdateModel
) => {
    await post(
        `${API.baseApiUrl}/2adpro/export?&matspec=${materialSpecificationId}`,
        {
            salesRep,
            adDesign,
            adSize,
            digitalBrief,
        },
        {
            headers: {
                ...headers,
                "Content-Type": "application/json",
            },
        }
    );

    return OK;
};
